<template>
  <div>
    <BjPage ref="BjPage"
      :label-width="'80px'"
      :default-sort="defaultSort"
      :query-params="queryParams" :col-span="colSpan"
      :get-action="queryApi" :serial="false" :auto-fetch="false"
      :right-toolbar-hide="true"
      :search-btn-hide="true"
      @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
      @sort-change="sortChange"
      @afterFetchOriginalData="afterFetchOriginalData"
      >
      <template v-slot:tableColumn>
        <vxe-column type="expand" width="40">
          <template #content="{ row }">
            <div style="padding:10px 20px;">
              <vxe-table :data="row.childDataList" :empty-text="$t('table.emptyText')">
                <vxe-column field="company" :title="$t('billingPage.Company')"></vxe-column>
                <vxe-column field="income" :title="$t('billingPage.Income')"></vxe-column>
                <vxe-column field="cost" :title="$t('billingPage.Cost')"></vxe-column>
                <vxe-column field="grossProfit" :title="$t('billingPage.GrossProfit')"></vxe-column>
                <vxe-column field="profitMargin" :title="$t('billingPage.ProfitMargin')"></vxe-column>
              </vxe-table>
            </div>
          </template>
        </vxe-column>
        <template v-for="(col, index) in dropCols">
          <vxe-table-column :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :field="col.prop"
            sortable
            :prop="col.prop" :label="col.label" :width="col.width || 'auto'"
            :fixed="col.fixed || false" align="center" class-name="item"
            :title="col.label"
          >
          </vxe-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import { billApi } from '@/api';
import pageMiXin from '@/utils/page-mixin.js';

export default {
name: 'BillingPageInvoiceReportClient',
mixins: [pageMiXin],
props: {
  value: {
    type: Object,
    default: () => {
      return {};
    },
  }
},
data() {
  return {
    colSpan: 6,
    queryParams: {},
    queryApi: billApi.getInvoiceReportSales,
    labelList: [
      { label: 'billingPage.Sales', prop: 'salesName', isCheck: true, disabled: false },
      { label: 'billingPage.Company', prop: 'company', isCheck: true, disabled: false },
      { label: 'billingPage.Income', prop: 'income', isCheck: true, disabled: false },
      { label: 'billingPage.Cost', prop: 'cost', isCheck: true, disabled: false },
      { label: 'billingPage.GrossProfit', prop: 'grossProfit', isCheck: true, disabled: false },
      { label: 'billingPage.ProfitMargin', prop: 'profitMargin', isCheck: true, disabled: false },
    ],
    defaultSort: [{ 'field': 'salesName', 'order': 'desc' }],
  };
},
watch: {
  value: {
    handler(v) {
      this.queryParams = v || null;
    },
    immediate: true,
  },
},
mounted() {
  this.$refs.BjPage.pagingInfo.size = 100;
},
methods: {
  sortChange (column) {
    this.defaultSort = [{ field: column.field, order: column.order }];
    this.$emit('sortChange', column);
  },
  afterFetchOriginalData(res) {
      res.data.dataList.forEach(item => {
        item.income = `$${item.income}`;
        item.cost = `$${item.cost}`;
        item.grossProfit = `$${item.grossProfit}`;
        item.profitMargin = `${item.profitMargin}%`;
      });
      this.$nextTick(() => {
        this.$refs.BjPage.tableData = res.data.dataList;
      });
  },
},
};
</script>
